import { connect } from 'react-redux';
import { getCoreLevel } from '../../../publicSession/selectors';
var mapStateToProps = function (state) { return ({
    corePackage: getCoreLevel(state),
}); };
var mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=LogoWithCoreLevel.container.js.map